var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg66A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.908,14.137000953674317 c1.504,-2.31 1.779,-4.45 1.681,-5.6880000000000015 c-6.132,0.101 -5.696,-6.449 -1.3900000000000001,-6.449 c1.83,0 3.801,1.338 3.801,4.275 c0,2.724 -1.412,5.845 -4.092,7.862 zm13,0 c1.504,-2.31 1.779,-4.45 1.681,-5.6880000000000015 c-6.132,0.101 -5.696,-6.449 -1.3900000000000001,-6.449 c1.83,0 3.801,1.338 3.801,4.275 c0,2.724 -1.412,5.845 -4.092,7.862 zm-16.908,3.863 c6.108,-1.206 10,-6.584 10,-11.725 c0,-3.9699999999999998 -2.786,-6.275 -5.801,-6.275 c-2.615,0 -5.199,1.7970000000000002 -5.199,4.979 c0,2.601 1.905,4.757 4.396,5.149 c-0.21700000000000005,2.004 -2.165,4.911 -4.38,5.746 l0.984,2.126 zm13,0 c6.108,-1.206 10,-6.584 10,-11.725 c0,-3.9699999999999998 -2.786,-6.275 -5.801,-6.275 c-2.615,0 -5.199,1.7970000000000002 -5.199,4.979 c0,2.601 1.905,4.757 4.396,5.149 c-0.21700000000000005,2.004 -2.165,4.911 -4.38,5.746 l0.984,2.126 z",
    id: "svg_1",
    className: "selected",
    fill: "#e51a94",
    fillOpacity: 1,
    transform: "rotate(-180 12,9) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg66A);
export default __webpack_public_path__ + "static/media/66a.913a62572172e264d03409dbe4292e5f.svg";
export { ForwardRef as ReactComponent };